export default "__VITE_ASSET__DHtgiiOf__"